import { useEffect,useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';
import Loader from '@/shared-components/loader/Loader';

import PostListItem from './PostListItem';

import './styles/PostListItem.css';

function PostVirtualList({ items, onLoadMore }) {
  const containerRef = useRef(null);
  // pick up any scrollY we stashed in location.state and restore it
  const { state } = useLocation();
  const scrollY = state?.scrollY;
  const [restored, setRestored] = useState(scrollY == null);
  useEffect(() => {
    if (scrollY != null) {
      // wait until paint, then jump back
      setTimeout(() => window.scrollTo(0, scrollY), 0);
    }
    setRestored(true);
  }, [scrollY]);

  // show loader until we’ve done our scroll restoration
  if (!restored) {
    return <Loader />;
  }

  return (
    <InfiniteScroll
      ref={containerRef}
      className="profile-board__infinite-scroll-container"
      onLoadMore={onLoadMore}
      shouldLoadMore={items.data.length < items.totalDocs}
      offsetElements={3}
      listLength={items.data.length}
    >
      {({ infiniteScrollAssigner }) => (
        <div className="post-virtual-list__items">
          {items.data.map((item, idx) => (
            <div
              key={item._id}
              data-item-id={item._id}
              ref={infiniteScrollAssigner(idx)}
            >
              <PostListItem data={item} />
            </div>
          ))}
        </div>
      )}
    </InfiniteScroll>
  );
}

export default PostVirtualList;
